import React from 'react';

const ToolsIcon = ({ size = 24, fill = '#656263' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1154 21.2423L11.1769 14.273C10.8244 14.4256 10.466 14.5432 10.1019 14.6259C9.73782 14.7086 9.35128 14.75 8.9423 14.75C7.34615 14.75 5.98878 14.1907 4.8702 13.0721C3.75161 11.9535 3.19232 10.5961 3.19232 8.99998C3.19232 8.48331 3.25802 7.9894 3.38942 7.51825C3.52084 7.04712 3.7077 6.59873 3.95 6.17308L7.5423 9.74615L9.68847 7.59998L6.13465 4.0269C6.56028 3.7846 7.00546 3.59454 7.4702 3.45673C7.93495 3.31891 8.42565 3.25 8.9423 3.25C10.5384 3.25 11.8958 3.80929 13.0144 4.92788C14.133 6.04646 14.6923 7.40383 14.6923 8.99998C14.6923 9.42178 14.6525 9.81473 14.573 10.1788C14.4936 10.5429 14.3743 10.8949 14.2153 11.2346L21.1846 18.1731L18.1154 21.2423Z"
        fill={fill}
      />
    </svg>
  );
};

export default ToolsIcon;
